if (!customElements.get('product-inventory-2')) {
  class ProductInventory2 extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.variantInventory = this.getVariantInventory();

      // Get messages from data attributes (colours now handled by CSS classes)
      this.inStockMessage = this.dataset.inStockMessage;
      this.outOfStockMessage = this.dataset.outOfStockMessage;

      // Bind to variant change event
      const variantPicker = this.closest('.product-info').querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      // Initial inventory update
      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === 'true'
      );
    }

    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return this.variantInventory || JSON.parse(dataEl.textContent);
    }

    handleVariantChange(evt) {
      if (evt.detail.variant) {
        const inventory = this.variantInventory.filter(
          (variant) => variant.id === evt.detail.variant.id
        )[0];
        this.updateInventory(
          inventory.inventory_quantity,
          inventory.available
        );
      } else {
        this.updateInventory(0, false);
        this.hidden = true;
      }
    }

    updateInventory(count, available) {
  // Reset classes and tooltip
  this.inventoryNotice.classList.remove('green', 'amber');
  this.inventoryNotice.innerHTML = ''; // Clear previous content

  const message = available && count > 0 ? this.inStockMessage : this.outOfStockMessage;
  const statusClass = available && count > 0 ? 'green' : 'amber';
  const tooltipText = available && count > 0 
    ? 'We have stock on the shelf and ready to go straight away.' 
    : 'We need to make this product before we send it, this will add aditional time to your delivery choice.';

  // Create message span
  const messageSpan = document.createElement('span');
  messageSpan.textContent = message;

  // Create tooltip span
  const tooltipSpan = document.createElement('span');
  tooltipSpan.classList.add('product-inventory__tooltip');
  tooltipSpan.textContent = tooltipText;

  // Append both to the notice container
  this.inventoryNotice.appendChild(messageSpan);
  this.inventoryNotice.appendChild(tooltipSpan);

  this.inventoryNotice.classList.add(statusClass);
  this.hidden = false;
}

  }

  customElements.define('product-inventory-2', ProductInventory2);
}
